<template>
    <Modal :id="'cmp-distribution-order-check_confirm_order'" @cancelled="onCancel">
        <template slot="header"></template>
        <template slot="body">
            <div class="dt-details distribution-order-check_confirm_order_details">
                <div class="dt-details--body">
                    <div class="dt-details--col">
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('order_ref')">{{ $t('order_ref') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.order_with_details.order_reference }}
                            </div>
                        </div>
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('order_date')">{{ $t('order_date') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.order_with_details.order_date }}
                            </div>
                        </div>
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('delivery_date')">{{ $t('delivery_date') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.edi_order_json.deliver_date }}
                            </div>
                        </div>
                    </div>
                    <div class="dt-details--col">
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('order_account')">{{ $t('order_account') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.order_with_details.account_buyer_contact_company_name }}
                            </div>
                        </div>
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('order_gln')">{{ $t('order_gln') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.edi_order_json.order_account_no }}
                            </div>
                        </div>
                    </div>
                    <div class="dt-details--col">
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('invoice_account')">{{ $t('invoice_account') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.order_with_details.account_invoice_contact_company_name }}
                            </div>
                        </div>
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('invoice_gln')">{{ $t('invoice_gln') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.edi_order_json.invoice_account_no }}
                            </div>
                        </div>
                    </div>
                    <div class="dt-details--col">
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('deliver_account')">{{ $t('deliver_account') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.order_with_details.account_delivery_contact_company_name }}
                            </div>
                        </div>
                        <div class="dt-details--row">
                            <div class="dt-details--label" :title="$t('delivery_gln')">{{ $t('delivery_gln') }} </div>
                            <div style="padding-top: 7px;" class="dt-details--value">
                                {{ order.edi_order_json.delivery_account_no }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NTable class="distribution-order-check_confirm_order" :items="list" :config="createNTableConfig({
                headerStyle: 3,
                headerHeight: 52,
                rowHeight: 52,
            })
                " :headers="headers" :id="'distribution-order-check_confirm_order'">
                <template v-slot:thead="{ thcon }">
                    <tr style="color: var(--text-5)">
                        <th v-bind="thcon('barcode')">
                            <div class="ut-fc">
                                <span>{{ $t("catalog_no") }}</span>
                                <span>{{ $t("barcode") }}</span>
                            </div>
                        </th>
                        <th v-bind="thcon('format_name')">
                            <span> {{ $t("format") }} </span>
                            <span> {{ $t("label") }} </span>
                        </th>
                        <th v-bind="thcon('artist')">
                            <div class="ut-fc">
                                <span>{{ $t("artist") }}</span>
                                <span>{{ $t("ps_title") }}</span>
                            </div>
                        </th>

                        <th v-bind="thcon('imoprt_ppu')">
                            <div class="ut-fc">
                                <span>{{ $t("imoprt_ppu") }}</span>
                                <span>{{ $t("list_ppu_after_discount") }}</span>
                            </div>
                        </th>


                        <th v-bind="thcon('diff')">
                            <div class="ut-fc">
                                <span>{{ $t("diff") }}</span>
                            </div>
                        </th>
                        <th v-bind="thcon('order_qty')">
                            <div class="ut-fc">
                                <span>{{ $t("order_qty") }}</span>
                            </div>
                        </th>
                        <th v-bind="thcon('available')">
                            <div class="ut-fc">
                                <span>{{ $t("available") }}</span>
                            </div>
                        </th>
                        <th v-bind="thcon('approval')">
                            <div class="ut-fc">
                                <span>{{ $t("approval") }}</span>
                                <span>{{ $t("type") }}</span>
                            </div>
                        </th>
                    </tr>
                </template>
                <template v-slot:item="{ item, tdcon }">
                    <tr>
                        <td v-bind="tdcon('barcode')">
                            <div style="color:red" class="ut-fc ut-txtov">
                                <span class="txtov" :title="item['unknown_item']">{{
                                    $t('unknown_item') }}</span>
                                <span class="txtov" :title="item['edicot_product_barcode']">{{
                                    item["edicot_product_barcode"]
                                }}</span>
                            </div>
                        </td>
                        <td v-bind="tdcon('format_name')">
                            <div class="ut-fc ut-txtov">
                                <span class="txtov" :title="item['format']">{{
                                    item["format"] }}</span>
                                <span class="txtov " :title="item['labelname']">{{ item["labelname"]
                                }}</span>
                            </div>
                        </td>
                        <td v-bind="tdcon('artist')">
                            <div v-if="item.product_id" class="ut-fc ut-txtov">
                                <span class="txtov " :title="item['artist']">{{
                                    item["artist"] }}</span>
                                <span class="txtov " :title="item['title']">{{ item["title"]
                                }}</span>
                            </div>
                            <div v-else class="ut-fc ut-txtov">
                                <span style="color:red" class="txtov " :title="item['unknown_item']">{{
                                    $t('unknown_item') }}</span>
                            </div>
                        </td>
                        <td v-bind="tdcon('imoprt_ppu')">
                            <div class="ut-fc ut-txtov">
                                <span class="txtov " :title="item['import_ppu']">{{
                                    item["catalog_no"] }}</span>
                                <span v-if="item.list_price_after_discount" class="txtov"
                                    :title="item['list_price_after_discount']">{{ item["list_price_after_discount"]
                                    }}</span>
                                <span v-else style="color:red" class="txtov">error</span>
                            </div>
                        </td>
                        <td v-bind="tdcon('diff')">
                            <span class="ut-txtov" :title="item['diff_after_discount']">{{ item["diff_after_discount"]
                            }}</span>
                        </td>
                        <td v-bind="tdcon('order_qty')">
                            <span v-if="!item.product_id || order.edi_order_json.order_status != 'open'" class="ut-txtov"
                                :title="item['order_qty']">{{ item["order_qty"] }}</span>
                            <div style="margin:0px" v-else>
                                <TextField2 :bb="'0px'"  id="order_qty" :showLabel="false" :placeholder="$t('order_qty')"
                                    :value="item.order_qty" @blur="(e) => onTextFieldValueChange(e)" />
                            </div>
                        </td>
                        <td v-bind="tdcon('available')">
                            <span class="ut-txtov" :title="item['available_qty']">{{ item["available_qty"] }}</span>
                        </td>
                        <td v-bind="tdcon('approval')">
                            <span v-if="!item.product_id" class="ut-txtov">{{
                                $t('refused') }}</span>
                            <span style="margin:0px" v-else>
                                <Dropdown2 :bb="'0px'" class="dbox1" :showLabel="false" :placeholder="'Refusal Type'"
                                    :disabled="false" :options="refusal_typesTV || []" :selected="refusal_typesTV.find(
                                        (e) =>
                                            e.value ==
                                            item.refusal_type
                                    )" />
                            </span>
                        </td>
                    </tr>
                </template>
            </NTable>
        </template>
        <template slot="options">

            <button class="dt-button s6" @click.stop="onCancel">
                {{ $t("cancel") }}
            </button>
            <button v-if="order.edi_order_json.order_status == 'confirmed'" @click.stop="onUnconfirm"
                class="dt-button v1 s6">
                {{ $t("unconfirm_order") }}
            </button>
            <button v-else @click.stop="onConfirm" class="dt-button v1 s6">
                {{ $t("confirm_order") }}
            </button>
        </template>
    </Modal>
</template>
  
<script>
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import Modal from "@dtplugins/modal/modal";
import { createTextFieldConfig } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { OrderService } from "../../services/order.service";
import { createTV } from "../../../../models/text-value.model";
import {
    closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import FileDownload from "js-file-download";
export default {
    components: {
        Modal,
        NTable,
    },
    props: ['selectedEdiOrderTab'],
    async mounted() {
        const res = await OrderService.getEdiOrderProcessModalData(this.order_id);
        this.order = res.data || {};
    },
    data: function () {
        return {
            textFieldConfig: createTextFieldConfig({
                height: 42,
                showEditIconOnHover: false,
                box: true,
                showValidationIcons: false,
            }),
            order: {},

        };
    },
    computed: {
        order_id: function () {
            return this.$route.query.order_id;
        },
        list: function () {
            return this.order?.orders || [];
        },
        refusal_typesTV: function () {
            return createTV(
                this.order?.refusal_types,
                "value",
                "value"
            );
        },

        headers: function () {
            return [
                createTableHeader("barcode", { f: 1.1 }),
                createTableHeader("format_name",),
                createTableHeader("artist",),
                createTableHeader("imoprt_ppu",),
                createTableHeader("diff",),
                createTableHeader("order_qty",),
                createTableHeader("available",),
                createTableHeader("approval",),

            ];
        },

    },
    methods: {
        createNTableConfig: createNTableConfig,
        async onConfirm() {
            const res = await OrderService.confirmEdiOrder(this.order_id);
            this.onCancel();
            NotificationService.showNotification({
                text: this.$t('order_confirmed'),
                timeout: 2000,
                type: "normal",
            });
            this.$emit("load", true);
        },
        onTextFieldValueChange: function (e) {
            const payload = {
                name: e.name,
                value: e.value,
            };
            this.$emit("changed", payload);
        },
        async onUnconfirm() {
            const res = await OrderService.unConfirmEdiOrder(this.order_id);
            this.onCancel();
            NotificationService.showNotification({
                text: this.$t('order_unconfirmed'),
                timeout: 2000,
                type: "normal",
            });
            this.$emit("load", true);
        },
        onCancel: function () {
            closeModalRoute(this);
        },
        onExport: async function () {
            const order_ids = this.selectedEdiOrderTab?.orders.map(o => o.order_id).join(',') || ''
            const res = await OrderService.exportEdiBarcodeCheckErrors(
                order_ids
            );
            console.log({ fileURL: res.data });
            FileDownload(
                res.data,
                `Barcode_Errors_Remaining_${new Date().toUTCString()}.xlsx`
            );
        }
        //MARK: Methods
    },
};
</script>
  
<style lang="scss">
.cmp-distribution-order-check_confirm_order {
    .distribution-order-check_confirm_order {
        --ntable-height: 400px !important;
        border: 1px solid rgba(128, 128, 128, 0.158);
        background: #f8f8f8;



    }

    .dt-details .dt-details--body .dt-details--col {
        border: none;

    }

    .dt-details .dt-details--body .dt-details--col .dt-details--row:not(:last-child) {
        border: none;
    }

    .dt-details .dt-details--body .dt-details--col:not(:first-child) {
        border: none;
    }

    .dt-modal--header {
        margin: 0 !important;
    }
}
</style>
  